<template>
  <v-container>
        <v-tabs
          icons-and-text
          color="light-green"
          stacked
          :grow="!$vuetify.display.mdAndUp"
          :model-value="selectedTab"
        >
          <v-tab
            :value="$t('news.faculties')"
            :to="{name: 'Faculties'}"
            data-cy="faculties-tab"
            color="light-green"
            active-color="light-green"
          >
            <v-icon>meeting_room</v-icon>
            <div v-if="$vuetify.display.mdAndUp">{{ $t("news.faculties") }}</div>
          </v-tab>
          <v-tab
            :value="$t('news.users_and_permissions')"
            :to="{name: 'Administrators'}"
            data-cy="administrators-tab"
            color="light-green"
            active-color="light-green"
          >
            <v-icon>account_box</v-icon>
            <div v-if="$vuetify.display.mdAndUp">{{ $t("news.users_and_permissions") }}</div>
          </v-tab>
          <v-tab
            :value="$t('news.statistics')"
            :to="{name: 'NewsfeedStatistics'}"
            data-cy="statistics-tab"
            color="light-green"
            active-color="light-green"
          >
            <v-icon>insights</v-icon>
            <div v-if="$vuetify.display.mdAndUp">{{ $t("news.statistics") }}</div>
          </v-tab>
        </v-tabs>

        <router-view class="pt-6" />

  </v-container>
</template>

<script>
import i18n from "@/localization/i18n";

const t = i18n.global.t
export default {
  name: "News",

  computed: {
    selectedTab() {
      let path = this.$route.path

      if(path.includes('faculties')){
        return t('news.faculties')
      }
      if(path.includes('administrators')){
        return t('news.users_and_permissions')
      }
      if(path.includes('statistics')){
        return t('news.statistics')
      }
      return path
    }
  },
};
</script>

<style scoped>

</style>
